module.exports = __webpack_public_path__ + "static/media/cq_pratiche.ac474835.svg";